import { APPROVE_STEP, UNAPPROVE_STEP } from "modules/approval/steps/actions";
import { GET_CURRENT_USER, SET_CURRENT_PROJECT, READ_NOTIFICATION, ADD_NOTIFICATION } from "./actions";

export function CurrentUserReducer(state = {}, action) {
  switch (action.type) {
    case `${GET_CURRENT_USER}_FULFILLED`:
    case `${SET_CURRENT_PROJECT}_FULFILLED`:
    case `${READ_NOTIFICATION}_FULFILLED`:
      return action.payload.data;
    case `${ADD_NOTIFICATION}`: {
      let newState = _.cloneDeep(state);
      newState.notifications.unshift(action.data);
      return newState;
    }
    case `${UNAPPROVE_STEP}_FULFILLED`:
    case `${APPROVE_STEP}_FULFILLED`: {
      let newState = _.clone(state);
      const newItem = action.payload.data;
      const id = _.get(newItem, "id");
      newState[id] = newItem;
      return newState;
    }

    default:
      return state;
  }
}
